import { render, staticRenderFns } from "./PlateHistoryResults.vue?vue&type=template&id=4e3d7f1c&scoped=true&"
import script from "./PlateHistoryResults.vue?vue&type=script&lang=js&"
export * from "./PlateHistoryResults.vue?vue&type=script&lang=js&"
import style0 from "./PlateHistoryResults.vue?vue&type=style&index=0&id=4e3d7f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d7f1c",
  null
  
)

export default component.exports